// --------------------------------------------------------------------------
// select.js
// --------------------------------------------------------------------------
// Uses Selectron for custom selects
// --------------------------------------------------------------------------

RN.select = function() {

    'use strict';

    function init() {
        byBehaviour('select').selectron();
    }

    return {
        init: init
    };

}();